import React, {Component} from 'react';

import {Photos} from '../common/vars';

import _500px from '../common/500px';

import '../../styles/components/imageGrid.css';

import ImageGridElement from '../elements/ImageGridElement';

class ImageGrid extends Component {

  /*
  process500pxApi(response) {
    let $return = [];
    response.map(function (e, i) {
      $return[i] = {};
      $return[i].name = e.name;
      $return[i].img = {};
      $return[i].img.s3 = e.images[0].url;
      $return[i].img.s20 = e.images[1].url;
      $return[i].img.s440 = e.images[2].url;
      $return[i].url = 'https://500px.com'+e.url;
    });

    return $return;
  }
  */

  constructor() {
    super();

    this.state = {
      photos: [],
      shouldUpdate: true
    };

    if (_500px.needInit()) {
      _500px.init({
        sdk_key: '83a542aa375f9693e544febbcadd1e7d5b56005b'
      });
    }

    _500px.api('/photos', {
      feature: 'user',
      username: 'andermurias',
      sort: 'created_at',
      image_size: '3,20,440'
    }, function (response) {

      let photos = [];

      if (response.success) {
        for(let i in response.data.photos) {
          const e = response.data.photos[i];
          photos[i] = {};
          photos[i].name = e.name;
          photos[i].img = {};
          photos[i].img.s3 = e.images[0].url;
          photos[i].img.s20 = e.images[1].url;
          photos[i].img.s440 = e.images[2].url;
          photos[i].url = 'https://500px.com' + e.url;
          photos[i].parentRef = null;
        }
      } else {
        photos = Photos;
      }
      this.setState({photos: photos, shouldUpdate: true});

    }.bind(this));

  }

  shouldComponentUpdate(nextProps, nextState) {
    if(!nextState.shouldUpdate) {
      return false;
    }
    return true;
  }

  handleImageLoaded(i) {
    // eslint-disable-next-line react/no-direct-mutation-state
    let photos = this.state.photos;
    photos[i].parentRef.classList.add('image-grid__container--show');
    this.setState({
      photos: photos,
      shouldUpdate: false
    })
  }

  updatePhotoElement(i, elem) {
    // eslint-disable-next-line react/no-direct-mutation-state
    let photos = this.state.photos;
    photos[i].parentRef = elem;
    this.setState({
      photos: photos,
      shouldUpdate: false
    })
  }

  render() {
    return (
      <div className="image-grid">
        {this.state.photos.map((photo, i) => {
          return (
            <ImageGridElement photo={photo} i={i} key={'ige_'+i} />
            )
        })}
      </div>
    )
  }
}

export default ImageGrid;



// WEBPACK FOOTER //
// ./src/js/components/ImageGrid.js